<div class="preview-actions-container mb-3">
  <ng-container *ngIf="client || subProject.id == null; else admin">
    <button
      *ngIf="
        subProject.id != null && subProject.status !== STATUS.DRAFT.valueOf()
      "
      class="btn btn-close mr-2"
      mat-flat-button
      (click)="closeTab()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <button
      *ngIf="
        (subProject.id == null ||
          subProject.status === STATUS.DRAFT.valueOf()) &&
        !submitting
      "
      class="btn btn-cancel mr-2"
      mat-flat-button
      (click)="cancel()"
    >
      Annuleren
    </button>
    <button
      *ngIf="
        (subProject.id == null ||
          subProject.status === STATUS.DRAFT.valueOf()) &&
        !submitting
      "
      class="btn btn-submit"
      mat-flat-button
      (click)="submit()"
    >
      Indienen
    </button>
    <mat-spinner
      *ngIf="submitting"
      class="mr-2"
      color="primary"
      diameter="48"
    ></mat-spinner>
  </ng-container>
  <ng-template #admin>
    <ng-container *ngIf="!subProject.fromOldSystem; else fromOldSystem">
      <button
        class="btn btn-print mr-2"
        mat-flat-button
        (click)="openPrintworkDialog()"
      >
        Printwerk nodig
      </button>
      <ng-container *ngIf="!openedFromAppointment">
        <div
          [matTooltip]="'De job staat on hold'"
          [matTooltipDisabled]="!subProject.onHold"
        >
          <button
            [disabled]="subProject.onHold"
            class="btn btn-hold mr-2"
            mat-flat-button
            (click)="openOnHoldDialog()"
          >
            On Hold
          </button>
          <button
            *ngIf="!designState"
            class="btn btn-design mr-2"
            mat-flat-button
            (click)="openDesignDialog()"
          >
            Ontwerp Extern
          </button>
        </div>
        <div
          *ngIf="designState"
          [matTooltip]="
            'De job staat on hold, ontwerp als klaar markeren is niet mogelijk'
          "
          [matTooltipDisabled]="!subProject.onHold"
        >
          <button
            [disabled]="subProject.onHold"
            class="btn btn-approve"
            mat-flat-button
            (click)="setDesignFinished()"
          >
            Ontwerp klaar
          </button>
        </div>
        <div
          *ngIf="!designState"
          [matTooltip]="
            subProject.onHold
              ? 'De job staat on hold, goedkeuren is niet mogelijk'
              : approvalBlockedByDesign
              ? 'Kan job niet goedkeuren zonder design'
              : approvalBlockedByStockShortage
              ? 'Er is niet genoeg fysieke stock aanwezig om deze job goed te keuren'
              : ''
          "
          [matTooltipDisabled]="
            !subProject.onHold &&
            !approvalBlockedByDesign &&
            !approvalBlockedByStockShortage
          "
        >
          <button
            *ngIf="!subProject.approved"
            [disabled]="
              subProject.onHold ||
              approvalBlockedByDesign ||
              approvalBlockedByStockShortage
            "
            class="btn btn-approve"
            mat-flat-button
            (click)="approveBaseProject()"
          >
            Goedkeuren
          </button>
          <button
            *ngIf="subProject.approved"
            class="btn btn-unapprove"
            mat-flat-button
            (click)="unapproveBaseProject()"
          >
            Goedkeuren annuleren
          </button>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #fromOldSystem>
      <button
        *ngIf="subProject.id == null && !submitting"
        class="btn btn-submit"
        mat-flat-button
        (click)="submit()"
      >
        Indienen
      </button>
      <mat-spinner
        *ngIf="submitting"
        class="mr-2"
        color="primary"
        diameter="48"
      ></mat-spinner>
    </ng-template>
  </ng-template>
</div>
<div *ngIf="loadBeforeClose" class="load-container">
  <mat-spinner style="margin: auto" color="primary" diameter="48"></mat-spinner>
</div>
